import {IFileVariantResponseEntity} from 'frontend/common/files/types/i-file-variant-response-entity'
import {useDevicePixelRatio} from '@vueuse/core'

export function useBestFileVariant() {
  const {pixelRatio} = useDevicePixelRatio()

  function getBestFileVariantBySize(
    fileVariants: IFileVariantResponseEntity[],
    elementWidth: number,
    elementHeight: number
  ): IFileVariantResponseEntity {
    const filteredVariants = fileVariants?.filter(variant => {
      const actualDimensions = [
        variant.dimensions?.[0] ?? variant.limitDimensions?.[0],
        variant.dimensions?.[1] ?? variant.limitDimensions?.[1],
      ]
      return actualDimensions[0] !== null && actualDimensions[1] !== null
    })
    if(!filteredVariants?.length) {
      return null
    }
    const elementArea = elementWidth * elementHeight * pixelRatio.value
    const elementRatio = elementWidth / elementHeight
    const variantsWithMatchingRatio = filteredVariants.filter(variant => {
      const actualDimensions = [
        variant.dimensions?.[0] ?? variant.limitDimensions?.[0],
        variant.dimensions?.[1] ?? variant.limitDimensions?.[1],
      ]
      if(!actualDimensions[0] || !actualDimensions[1]) {
        return false
      }
      const variantRatio = actualDimensions[0] / actualDimensions[1]
      return Math.abs(variantRatio - elementRatio) < 0.1
    })

    const targetVariants = variantsWithMatchingRatio.length > 0 ? variantsWithMatchingRatio : filteredVariants
    return targetVariants.reduce((prev, curr) => {
      const currDimensions = [
        curr.dimensions?.[0] ?? curr.limitDimensions?.[0],
        curr.dimensions?.[1] ?? curr.limitDimensions?.[1],
      ]
      const prevDimensions = [
        prev.dimensions?.[0] ?? prev.limitDimensions?.[0],
        prev.dimensions?.[1] ?? prev.limitDimensions?.[1],
      ]

      const prevArea = prevDimensions[0] * prevDimensions[1]
      const currArea = currDimensions[0] * currDimensions[1]
      return Math.abs(prevArea - elementArea) < Math.abs(currArea - elementArea) ? prev : curr
    }) || null
  }

  return {
    getBestFileVariantBySize,
  }
}